export let hybridspaceEmployee = "opkrb";
export let hybridspaceAdmin = "PkTAE";
export let hybridspaceViewAs = "tfiqY";
export default {hybridspaceEmployee,hybridspaceAdmin,hybridspaceViewAs};